module.exports = __webpack_public_path__ + "img/rede-familia-2022.670b0e45.png";